import { Link } from 'react-router-dom';
import './Footer.css'
import { withUtm, trackEvent } from '../../utils/tracking';
import Wordmark from '../ui/Wordmark';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

function XIcon({ size = 20 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
    );
}

export default function Footer() {
    return (
        <footer className="border-t border-line bg-canvas text-muted relative overflow-hidden">

            <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">

                {/* Top Section */}
                <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between mb-10">

                    {/* Logo */}
                    <div>
                        <Link to="/">
                            <Wordmark />
                        </Link>
                    </div>

                    {/* Social Icons */}
                    <div className="flex gap-2 text-gray-400 text-lg social-icons">
                        <a href="https://www.linkedin.com/company/accruewise/" aria-label="LinkedIn" className="text-ink transition-opacity hover:opacity-70" onClick={() => trackEvent("social_click", { social_network: "LinkedIn" })}>
                            <Linkedin size={20} />
                        </a>
                        <a href="https://x.com/accruewise" aria-label="X" className="text-ink transition-opacity hover:opacity-70" onClick={() => trackEvent("social_click", { social_network: "X" })}>
                            <XIcon />
                        </a>
                        <a href="https://www.instagram.com/accruewise/" aria-label="Instagram" className="text-ink transition-opacity hover:opacity-70" onClick={() => trackEvent("social_click", { social_network: "Instagram" })}>
                            <Instagram size={20} />
                        </a>
                        <a href="https://www.facebook.com/accruewise/" aria-label="Facebook" className="text-ink transition-opacity hover:opacity-70" onClick={() => trackEvent("social_click", { social_network: "Facebook" })}>
                            <Facebook size={20} />
                        </a>
                    </div>
                </div>

                {/* Gradient Divider */}
                <div className="h-[1px] w-full mb-10 bg-line"></div>

                {/* Links Grid */}
                <div className="grid grid-cols-2 md:grid-cols-3 px-4 gap-10 content-section">

                    <div>
                        <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.16em] text-ink">About</h3>
                        <ul className="space-y-1">
                            <li><Link to="/about-us" className="cursor-pointer transition-colors hover:text-ink">About Us</Link></li>
                            <li><Link to="/ai-agents" className="cursor-pointer transition-colors hover:text-ink">AI Agents</Link></li>
                            <li><a href={withUtm("https://blog.accruewise.in", "footer", "footer")} className="cursor-pointer transition-colors hover:text-ink" target="_blank" rel="noreferrer" onClick={() => trackEvent("outbound_click", { link_domain: "blog.accruewise.in", link_placement: "footer" })}>Blogs</a></li>
                            {/* <li>Blog</li>
                            <li>Contact Us</li> */}
                        </ul>
                    </div>


                    {/* <div>
                        <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.16em] text-ink">Resources</h3>
                        <ul className="space-y-2">
                            <li>Help Center</li>
                            <li>API Documentation</li>
                            <li>Community</li>
                            <li>Partners</li>
                        </ul>
                    </div> */}

                    <div>
                        <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.16em] text-ink">Policies</h3>
                        <ul className="space-y-1">
                            <li><Link to="/privacy-policy" className="cursor-pointer transition-colors hover:text-ink">Privacy Policy</Link></li>
                            <li><Link to="/terms-and-conditions" className="cursor-pointer transition-colors hover:text-ink">Terms of Service</Link></li>
                            <li><Link to="/refund-and-cancellation" className="cursor-pointer transition-colors hover:text-ink">Refund and Cancellation</Link></li>
                            <li><Link to="/grievance-redressal-policy" className="cursor-pointer transition-colors hover:text-ink">Grievance Redressal</Link></li>
                        </ul>
                    </div>

                    {/* <div>
                        <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.16em] text-ink">Products</h3>
                        <ul className="space-y-1">
                            <li>For Personal</li>
                            <li>For Business</li>
                            <li>Payment Solutions</li>
                            <li>Integrations</li>
                        </ul>
                    </div> */}

                    <div>
                        <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.16em] text-ink">Support</h3>
                        <ul className="space-y-1">
                            <li><Link to="/contact-us" className="cursor-pointer transition-colors hover:text-ink">Contact Us</Link></li>
                            <li><Link to="/faqs" className="cursor-pointer transition-colors hover:text-ink">FAQ</Link></li>
                            {/* <li>Report a Problem</li>
                            <li>Security & Privacy</li> */}
                        </ul>
                    </div>

                </div>
                {/* Huge Background Text */}
                <div className="footer-watermark" aria-hidden="true">
                    <span className="footer-watermark__text">ACCRUEWISE</span>
                </div>

                {/* Bottom Divider */}
                <div className="footer-bottom-divider h-[1px] w-full bg-line"></div>

                {/* Bottom Section */}
                <div className="pt-6 text-sm leading-6">
                    <div>
                        ©{new Date().getFullYear()} ACCRUEWISE TECHNOLOGIES PRIVATE LIMITED. All Rights Reserved.
                    </div>
                    <p className="mt-3 max-w-4xl text-xs leading-6 text-muted">
                        Registered office: 24th Floor, Tower B, Alphathum Plot No 1 Sec 90, Nepz Post Office,
                        Gautam Buddha Nagar, Noida, Uttar Pradesh, India, 201305.
                    </p>
                </div>

            </div>
        </footer >
    );
}